var _rect, _feGaussianBlur, _feGaussianBlur2, _feGaussianBlur3, _feGaussianBlur4, _feGaussianBlur5, _feGaussianBlur6, _feGaussianBlur7, _feGaussianBlur8, _feGaussianBlur9, _feGaussianBlur10, _feGaussianBlur11, _feGaussianBlur12, _feGaussianBlur13, _feGaussianBlur14, _feGaussianBlur15, _feGaussianBlur16, _feGaussianBlur17, _feGaussianBlur18, _feGaussianBlur19, _feGaussianBlur20, _feGaussianBlur21, _feGaussianBlur22, _feGaussianBlur23, _feGaussianBlur24, _feGaussianBlur25, _feGaussianBlur26, _feGaussianBlur27, _feGaussianBlur28, _feGaussianBlur29, _feGaussianBlur30, _feGaussianBlur31, _feGaussianBlur32, _feGaussianBlur33, _feGaussianBlur34, _feGaussianBlur35, _feGaussianBlur36, _feGaussianBlur37, _feGaussianBlur38, _feGaussianBlur39, _feGaussianBlur40, _feGaussianBlur41, _feGaussianBlur42, _feGaussianBlur43, _feTurbulence, _feColorMatrix, _feColorMatrix2, _feComposite, _feColorMatrix3, _feComposite2, _feComposite3, _feComposite4, _feDisplacementMap, _feColorMatrix4, _feTurbulence2, _feColorMatrix5, _feColorMatrix6, _feComposite5, _feColorMatrix7, _feComposite6, _feComposite7, _feComposite8, _feDisplacementMap2, _feTurbulence3, _feConvolveMatrix, _feConvolveMatrix2, _feColorMatrix8, _feComposite9, _feTurbulence4, _feDisplacementMap3, _feBlend, _feColorMatrix9, _feDiffuseLighting, _feComposite10, _feBlend2, _feComposite11, _feGaussianBlur44, _feComposite12, _feComposite13, _feOffset, _feDisplacementMap4, _feComposite14, _feComposite15, _feComposite16, _feComposite17, _feGaussianBlur45, _feComposite18, _feComposite19, _feOffset2, _feDisplacementMap5, _feComposite20, _feComposite21, _feComposite22, _feComposite23, _feGaussianBlur46, _feOffset3, _feComposite24, _feComposite25, _feColorMatrix10, _feFlood, _feBlend3, _feBlend4, _feColorMatrix11, _feComposite26, _feColorMatrix12, _feColorMatrix13, _feComposite27, _feGaussianBlur47, _feGaussianBlur48, _feBlend5, _feGaussianBlur49, _feOffset4, _feComposite28, _feColorMatrix14, _feColorMatrix15, _feComposite29, _feFlood2, _feComposite30, _feComposite31, _feGaussianBlur50, _feOffset5, _feFlood3, _feMerge, _feComposite32, _feColorMatrix16, _feOffset6, _feGaussianBlur51, _feFlood4, _feComposite33, _feBlend6, _feGaussianBlur52, _feOffset7, _feComposite34, _linearGradient, _feGaussianBlur53, _linearGradient2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404Sands1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1400,
    height: 700,
    viewBox: "0 0 1400 700",
    id: "svg5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient11611"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#58979b",
      stopOpacity: 1
    },
    offset: 0.18181819,
    id: "stop11607"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#e4e8d7",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop11609"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5841"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2f0ef",
      stopOpacity: 0.76691729
    },
    offset: 0.10047849,
    id: "stop5837"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f2dfcb",
      stopOpacity: 0.76691729
    },
    offset: 1,
    id: "stop5839"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 659.02352,
    y: 80.610173,
    width: 961.66523,
    height: 719.8347,
    id: "rect472"
  })), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter61927",
    x: -0.037252338,
    y: -0.037252338,
    width: 1.0745047,
    height: 1.0745047
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.32894002,
    id: "feGaussianBlur61925"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter61935",
    x: -0.052785466,
    y: -0.052785466,
    width: 1.1055709,
    height: 1.1055709
  }, _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.46609834,
    id: "feGaussianBlur61933"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter61949",
    x: -0.032840405,
    y: -0.032840405,
    width: 1.0656808,
    height: 1.0656808
  }, _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28998244,
    id: "feGaussianBlur61947"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter61955",
    x: -0.052490101,
    y: -0.052490101,
    width: 1.1049802,
    height: 1.1049802
  }, _feGaussianBlur4 || (_feGaussianBlur4 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.46349025,
    id: "feGaussianBlur61953"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter61967",
    x: -0.077157507,
    y: -0.077157507,
    width: 1.154315,
    height: 1.154315
  }, _feGaussianBlur5 || (_feGaussianBlur5 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6813047,
    id: "feGaussianBlur61965"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter61975",
    x: -0.042107878,
    y: -0.042107878,
    width: 1.0842158,
    height: 1.0842158
  }, _feGaussianBlur6 || (_feGaussianBlur6 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3718147,
    id: "feGaussianBlur61973"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter61985",
    x: -0.11473226,
    y: -0.11473226,
    width: 1.2294645,
    height: 1.2294645
  }, _feGaussianBlur7 || (_feGaussianBlur7 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0130917,
    id: "feGaussianBlur61983"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter61993",
    x: -0.043305034,
    y: -0.043305034,
    width: 1.0866101,
    height: 1.0866101
  }, _feGaussianBlur8 || (_feGaussianBlur8 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.38238565,
    id: "feGaussianBlur61991"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62005",
    x: -0.10891862,
    y: -0.10891862,
    width: 1.2178372,
    height: 1.2178372
  }, _feGaussianBlur9 || (_feGaussianBlur9 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.96175694,
    id: "feGaussianBlur62003"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62011",
    x: -0.057336734,
    y: -0.057336734,
    width: 1.1146735,
    height: 1.1146735
  }, _feGaussianBlur10 || (_feGaussianBlur10 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.50628626,
    id: "feGaussianBlur62009"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62017",
    x: -0.0085554046,
    y: -0.0085554046,
    width: 1.0171108,
    height: 1.0171108
  }, _feGaussianBlur11 || (_feGaussianBlur11 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075544656,
    id: "feGaussianBlur62015"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62025",
    x: -0.10716073,
    y: -0.10716073,
    width: 1.2143215,
    height: 1.2143215
  }, _feGaussianBlur12 || (_feGaussianBlur12 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.94623463,
    id: "feGaussianBlur62023"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62031",
    x: -0.090113572,
    y: -0.090113572,
    width: 1.1802271,
    height: 1.1802271
  }, _feGaussianBlur13 || (_feGaussianBlur13 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.79570743,
    id: "feGaussianBlur62029"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62043",
    x: -0.035976827,
    y: -0.035976827,
    width: 1.0719537,
    height: 1.0719537
  }, _feGaussianBlur14 || (_feGaussianBlur14 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3176772,
    id: "feGaussianBlur62041"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62049",
    x: -0.038412253,
    y: -0.038412253,
    width: 1.0768245,
    height: 1.0768245
  }, _feGaussianBlur15 || (_feGaussianBlur15 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.33918214,
    id: "feGaussianBlur62047"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62073",
    x: -0.080797858,
    y: -0.080797858,
    width: 1.1615957,
    height: 1.1615957
  }, _feGaussianBlur16 || (_feGaussianBlur16 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7134492,
    id: "feGaussianBlur62071"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62079",
    x: -0.10250433,
    y: -0.10250433,
    width: 1.2050087,
    height: 1.2050087
  }, _feGaussianBlur17 || (_feGaussianBlur17 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.90511847,
    id: "feGaussianBlur62077"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62085",
    x: -0.10705975,
    y: -0.10705975,
    width: 1.2141195,
    height: 1.2141195
  }, _feGaussianBlur18 || (_feGaussianBlur18 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.94534302,
    id: "feGaussianBlur62083"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62095",
    x: -0.07328912,
    y: -0.07328912,
    width: 1.1465782,
    height: 1.1465782
  }, _feGaussianBlur19 || (_feGaussianBlur19 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.64714662,
    id: "feGaussianBlur62093"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62105",
    x: -0.037584405,
    y: -0.037584405,
    width: 1.0751688,
    height: 1.0751688
  }, _feGaussianBlur20 || (_feGaussianBlur20 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3318722,
    id: "feGaussianBlur62103"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62111",
    x: -0.097549233,
    y: -0.097549233,
    width: 1.1950985,
    height: 1.1950985
  }, _feGaussianBlur21 || (_feGaussianBlur21 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.86136468,
    id: "feGaussianBlur62109"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62119",
    x: -0.11258092,
    y: -0.11258092,
    width: 1.2251618,
    height: 1.2251618
  }, _feGaussianBlur22 || (_feGaussianBlur22 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.99409524,
    id: "feGaussianBlur62117"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62127",
    x: -0.04484458,
    y: -0.04484458,
    width: 1.0896892,
    height: 1.0896892
  }, _feGaussianBlur23 || (_feGaussianBlur23 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.39597992,
    id: "feGaussianBlur62125"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62135",
    x: -0.09478603,
    y: -0.09478603,
    width: 1.1895721,
    height: 1.1895721
  }, _feGaussianBlur24 || (_feGaussianBlur24 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.83696543,
    id: "feGaussianBlur62133"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62143",
    x: -0.089347357,
    y: -0.089347357,
    width: 1.1786947,
    height: 1.1786947
  }, _feGaussianBlur25 || (_feGaussianBlur25 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7889417,
    id: "feGaussianBlur62141"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62149",
    x: -0.11039588,
    y: -0.11039588,
    width: 1.2207918,
    height: 1.2207918
  }, _feGaussianBlur26 || (_feGaussianBlur26 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.97480117,
    id: "feGaussianBlur62147"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62157",
    x: -0.11974781,
    y: -0.11974781,
    width: 1.2394956,
    height: 1.2394956
  }, _feGaussianBlur27 || (_feGaussianBlur27 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0573792,
    id: "feGaussianBlur62155"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62163",
    x: -0.084276934,
    y: -0.084276934,
    width: 1.1685539,
    height: 1.1685539
  }, _feGaussianBlur28 || (_feGaussianBlur28 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.74416958,
    id: "feGaussianBlur62161"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62173",
    x: -0.052594084,
    y: -0.052594084,
    width: 1.1051882,
    height: 1.1051882
  }, _feGaussianBlur29 || (_feGaussianBlur29 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.46440844,
    id: "feGaussianBlur62171"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62179",
    x: -0.070079034,
    y: -0.070079034,
    width: 1.1401581,
    height: 1.1401581
  }, _feGaussianBlur30 || (_feGaussianBlur30 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.61880141,
    id: "feGaussianBlur62177"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62189",
    x: -0.023178561,
    y: -0.023178561,
    width: 1.0463571,
    height: 1.0463571
  }, _feGaussianBlur31 || (_feGaussianBlur31 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.20466787,
    id: "feGaussianBlur62187"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62199",
    x: -0.025049469,
    y: -0.025049469,
    width: 1.0500989,
    height: 1.0500989
  }, _feGaussianBlur32 || (_feGaussianBlur32 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22118809,
    id: "feGaussianBlur62197"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62205",
    x: -0.11389227,
    y: -0.11389227,
    width: 1.2277845,
    height: 1.2277845
  }, _feGaussianBlur33 || (_feGaussianBlur33 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.0056745,
    id: "feGaussianBlur62203"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62219",
    x: -0.00063671979,
    y: -0.0030901282,
    width: 1.0012734,
    height: 1.0061803
  }, _feGaussianBlur34 || (_feGaussianBlur34 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.36850676,
    id: "feGaussianBlur62217"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62227",
    x: -0.033461694,
    y: -0.033461694,
    width: 1.0669234,
    height: 1.0669234
  }, _feGaussianBlur35 || (_feGaussianBlur35 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.29546845,
    id: "feGaussianBlur62225"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62235",
    x: -0.058480988,
    y: -0.058480988,
    width: 1.116962,
    height: 1.116962
  }, _feGaussianBlur36 || (_feGaussianBlur36 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.51639007,
    id: "feGaussianBlur62233"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62245",
    x: -0.010095119,
    y: -0.010095119,
    width: 1.0201902,
    height: 1.0201902
  }, _feGaussianBlur37 || (_feGaussianBlur37 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.089140415,
    id: "feGaussianBlur62243"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62257",
    x: -0.089377678,
    y: -0.089377678,
    width: 1.1787554,
    height: 1.1787554
  }, _feGaussianBlur38 || (_feGaussianBlur38 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.78920944,
    id: "feGaussianBlur62255"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62263",
    x: -0.00855578,
    y: -0.00855578,
    width: 1.0171116,
    height: 1.0171116
  }, _feGaussianBlur39 || (_feGaussianBlur39 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075547969,
    id: "feGaussianBlur62261"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62269",
    x: -0.046429757,
    y: -0.046429757,
    width: 1.0928595,
    height: 1.0928595
  }, _feGaussianBlur40 || (_feGaussianBlur40 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4099771,
    id: "feGaussianBlur62267"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62275",
    x: -0.091491134,
    y: -0.091491134,
    width: 1.1829823,
    height: 1.1829823
  }, _feGaussianBlur41 || (_feGaussianBlur41 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.80787135,
    id: "feGaussianBlur62273"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62281",
    x: -0.0001541187,
    y: -0.00074796879,
    width: 1.0003082,
    height: 1.0014959
  }, _feGaussianBlur42 || (_feGaussianBlur42 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.089197451,
    id: "feGaussianBlur62279"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62287",
    x: -0.007346875,
    y: -0.007346875,
    width: 1.0146937,
    height: 1.0146937
  }, _feGaussianBlur43 || (_feGaussianBlur43 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.064873275,
    id: "feGaussianBlur62285"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter62297",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    height: 1,
    width: 1,
    y: 0,
    x: 0,
    id: "filter123059"
  }, _feTurbulence || (_feTurbulence = /*#__PURE__*/React.createElement("feTurbulence", {
    seed: 149,
    type: "fractalNoise",
    baseFrequency: 1,
    numOctaves: 1,
    result: "result1",
    id: "feTurbulence123041"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "luminanceToAlpha",
    in: "SourceGraphic",
    result: "result0",
    id: "feColorMatrix123043"
  })), _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "result2",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.5 0 ",
    id: "feColorMatrix123045"
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    result: "result3",
    operator: "over",
    in: "result1",
    in2: "result2",
    id: "feComposite123047"
  })), _feColorMatrix3 || (_feColorMatrix3 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "result91",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 5 -3.2",
    id: "feColorMatrix123049"
  })), _feComposite2 || (_feComposite2 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result91",
    operator: "arithmetic",
    k1: 1.5,
    result: "result93",
    id: "feComposite123051",
    k2: 0,
    k3: 0,
    k4: 0
  })), _feComposite3 || (_feComposite3 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result93",
    in: "SourceGraphic",
    operator: "out",
    result: "result4",
    id: "feComposite123053"
  })), _feComposite4 || (_feComposite4 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result4",
    operator: "arithmetic",
    k2: 0.5,
    k1: 1,
    id: "feComposite123055",
    k3: 0,
    k4: 0
  })), _feDisplacementMap || (_feDisplacementMap = /*#__PURE__*/React.createElement("feDisplacementMap", {
    scale: 15,
    xChannelSelector: "R",
    yChannelSelector: "A",
    in2: "result1",
    result: "fbSourceGraphic",
    id: "feDisplacementMap123057"
  })), _feColorMatrix4 || (_feColorMatrix4 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix123087"
  })), _feTurbulence2 || (_feTurbulence2 = /*#__PURE__*/React.createElement("feTurbulence", {
    id: "feTurbulence123089",
    seed: 50,
    type: "fractalNoise",
    baseFrequency: 1,
    numOctaves: 3,
    result: "result1",
    in: "fbSourceGraphic"
  })), _feColorMatrix5 || (_feColorMatrix5 = /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "feColorMatrix123091",
    type: "luminanceToAlpha",
    in: "fbSourceGraphic",
    result: "result0"
  })), _feColorMatrix6 || (_feColorMatrix6 = /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "feColorMatrix123093",
    result: "result2",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.5 0 "
  })), _feComposite5 || (_feComposite5 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result2",
    id: "feComposite123095",
    result: "result3",
    operator: "over",
    in: "result1"
  })), _feColorMatrix7 || (_feColorMatrix7 = /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "feColorMatrix123097",
    result: "result91",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 5 -3.2"
  })), _feComposite6 || (_feComposite6 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result91",
    id: "feComposite123099",
    operator: "arithmetic",
    k1: 1.5,
    result: "result93",
    k2: 0,
    k3: 0,
    k4: 0
  })), _feComposite7 || (_feComposite7 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result93",
    id: "feComposite123101",
    in: "fbSourceGraphic",
    operator: "out",
    result: "result4"
  })), _feComposite8 || (_feComposite8 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result4",
    id: "feComposite123103",
    operator: "arithmetic",
    k2: 0.5,
    k1: 1,
    result: "result94",
    k3: 0,
    k4: 0
  })), _feDisplacementMap2 || (_feDisplacementMap2 = /*#__PURE__*/React.createElement("feDisplacementMap", {
    in2: "result1",
    id: "feDisplacementMap123105",
    scale: 15,
    xChannelSelector: "R",
    yChannelSelector: "A",
    result: "result92"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter123257",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, _feTurbulence3 || (_feTurbulence3 = /*#__PURE__*/React.createElement("feTurbulence", {
    numOctaves: 1,
    baseFrequency: 0.03215434083601286,
    id: "feTurbulence123229"
  })), _feConvolveMatrix || (_feConvolveMatrix = /*#__PURE__*/React.createElement("feConvolveMatrix", {
    order: "5 5",
    kernelMatrix: "-4 0 0 0 -4 0 -2 0 -2 0 0 0 -10 0 0 0 -2 0 -2 0 -4 0 0 0 -4 ",
    targetX: 2,
    targetY: 2,
    id: "feConvolveMatrix123231"
  })), _feConvolveMatrix2 || (_feConvolveMatrix2 = /*#__PURE__*/React.createElement("feConvolveMatrix", {
    order: "3 3",
    kernelMatrix: "2 0 2 0 -5 0 2 0 2 ",
    targetX: 1,
    targetY: 1,
    id: "feConvolveMatrix123233"
  })), _feColorMatrix8 || (_feColorMatrix8 = /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "saturate",
    result: "result1",
    id: "feColorMatrix123235"
  })), _feComposite9 || (_feComposite9 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "arithmetic",
    k1: 1.5,
    k2: 0.5,
    k3: 0.5,
    result: "result2",
    id: "feComposite123237",
    k4: 0
  })), _feTurbulence4 || (_feTurbulence4 = /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: 0.1,
    numOctaves: 5,
    type: "fractalNoise",
    result: "result8",
    id: "feTurbulence123239"
  })), _feDisplacementMap3 || (_feDisplacementMap3 = /*#__PURE__*/React.createElement("feDisplacementMap", {
    scale: 4,
    in2: "result8",
    in: "result2",
    id: "feDisplacementMap123241"
  })), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in2: "result1",
    mode: "normal",
    result: "result4",
    id: "feBlend123243"
  })), _feColorMatrix9 || (_feColorMatrix9 = /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "luminanceToAlpha",
    id: "feColorMatrix123245"
  })), _feDiffuseLighting || (_feDiffuseLighting = /*#__PURE__*/React.createElement("feDiffuseLighting", {
    surfaceScale: 7,
    diffuseConstant: 1,
    result: "result3",
    id: "feDiffuseLighting123249"
  }, /*#__PURE__*/React.createElement("feDistantLight", {
    azimuth: 180,
    elevation: 37,
    id: "feDistantLight123247"
  }))), _feComposite10 || (_feComposite10 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result4",
    operator: "arithmetic",
    k1: 1.5,
    k3: 0.5,
    result: "result5",
    id: "feComposite123251",
    k2: 0,
    k4: 0
  })), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "result3",
    mode: "normal",
    result: "result6",
    id: "feBlend123253"
  })), _feComposite11 || (_feComposite11 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in",
    result: "result7",
    id: "feComposite123255"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: -0.0086391875,
    width: 1.0172784,
    y: -0.041927701,
    height: 1.0838554,
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter123401"
  }, _feGaussianBlur44 || (_feGaussianBlur44 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 5,
    result: "result8",
    id: "feGaussianBlur123383"
  })), _feComposite12 || (_feComposite12 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result8",
    operator: "xor",
    result: "result19",
    id: "feComposite123385"
  })), _feComposite13 || (_feComposite13 = /*#__PURE__*/React.createElement("feComposite", {
    k2: 1,
    operator: "arithmetic",
    result: "result17",
    in2: "result8",
    id: "feComposite123387",
    k1: 0,
    k3: 0,
    k4: 0
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    result: "result18",
    in: "SourceGraphic",
    id: "feOffset123389"
  })), _feDisplacementMap4 || (_feDisplacementMap4 = /*#__PURE__*/React.createElement("feDisplacementMap", {
    in2: "result17",
    in: "result18",
    xChannelSelector: "A",
    yChannelSelector: "A",
    scale: 100,
    result: "result4",
    id: "feDisplacementMap123391"
  })), _feComposite14 || (_feComposite14 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result4",
    result: "result2",
    operator: "arithmetic",
    in: "SourceGraphic",
    k3: 1,
    id: "feComposite123393",
    k1: 0,
    k2: 0,
    k4: 0
  })), _feComposite15 || (_feComposite15 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    result: "fbSourceGraphic",
    in: "result2",
    operator: "in",
    id: "feComposite123395"
  })), _feComposite16 || (_feComposite16 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in",
    result: "result15",
    id: "feComposite123397"
  })), _feComposite17 || (_feComposite17 = /*#__PURE__*/React.createElement("feComposite", {
    result: "result16",
    in2: "SourceGraphic",
    operator: "in",
    in: "result15",
    id: "feComposite123399"
  }))), /*#__PURE__*/React.createElement("filter", {
    height: 1.8665047,
    y: -0.43325236,
    width: 1.0679584,
    x: -0.033979213,
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter123839"
  }, _feGaussianBlur45 || (_feGaussianBlur45 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.294963,
    result: "result8",
    in: "SourceGraphic",
    id: "feGaussianBlur123821"
  })), _feComposite18 || (_feComposite18 = /*#__PURE__*/React.createElement("feComposite", {
    operator: "xor",
    result: "result18",
    in2: "result8",
    id: "feComposite123823"
  })), _feComposite19 || (_feComposite19 = /*#__PURE__*/React.createElement("feComposite", {
    k2: 1,
    operator: "arithmetic",
    result: "result16",
    in2: "result18",
    in: "result8",
    id: "feComposite123825",
    k1: 0,
    k3: 0,
    k4: 0
  })), _feOffset2 || (_feOffset2 = /*#__PURE__*/React.createElement("feOffset", {
    result: "result17",
    in: "SourceGraphic",
    id: "feOffset123827"
  })), _feDisplacementMap5 || (_feDisplacementMap5 = /*#__PURE__*/React.createElement("feDisplacementMap", {
    in2: "result18",
    in: "result17",
    xChannelSelector: "A",
    yChannelSelector: "A",
    scale: 100,
    result: "result4",
    id: "feDisplacementMap123829"
  })), _feComposite20 || (_feComposite20 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result4",
    result: "result2",
    operator: "arithmetic",
    in: "SourceGraphic",
    k1: 0,
    k3: 1,
    id: "feComposite123831",
    k2: 0,
    k4: 0
  })), _feComposite21 || (_feComposite21 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result2",
    result: "fbSourceGraphic",
    in: "result16",
    operator: "in",
    id: "feComposite123833"
  })), _feComposite22 || (_feComposite22 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in",
    result: "result14",
    id: "feComposite123835"
  })), _feComposite23 || (_feComposite23 = /*#__PURE__*/React.createElement("feComposite", {
    result: "result15",
    in2: "SourceGraphic",
    operator: "in",
    in: "result14",
    id: "feComposite123837"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter259650",
    x: -0.013241726,
    y: -0.056005576,
    width: 1.0333802,
    height: 1.1411807
  }, _feGaussianBlur46 || (_feGaussianBlur46 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "result0",
    in: "SourceAlpha",
    stdDeviation: 4,
    id: "feGaussianBlur259644"
  })), _feOffset3 || (_feOffset3 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    result: "result4",
    id: "feOffset259646"
  })), _feComposite24 || (_feComposite24 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "result4",
    operator: "xor",
    result: "result3",
    id: "feComposite259648"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter261609",
    x: -0.017303532,
    y: -0.00028002822,
    width: 1.0346071,
    height: 1.0005601
  }, _feComposite25 || (_feComposite25 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "arithmetic",
    k1: 8.38323,
    k2: 0,
    result: "composite1",
    id: "feComposite261595",
    k3: 0,
    k4: 0
  })), _feColorMatrix10 || (_feColorMatrix10 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    values: 0,
    type: "saturate",
    result: "colormatrix1",
    id: "feColorMatrix261597"
  })), _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 1,
    floodColor: "rgb(23,16,12)",
    result: "flood1",
    id: "feFlood261599"
  })), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "darken",
    result: "blend1",
    id: "feBlend261601"
  })), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "darken",
    result: "blend2",
    id: "feBlend261603"
  })), _feColorMatrix11 || (_feColorMatrix11 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    values: 1,
    type: "saturate",
    result: "colormatrix2",
    id: "feColorMatrix261605"
  })), _feComposite26 || (_feComposite26 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic",
    id: "feComposite261607"
  })), _feColorMatrix12 || (_feColorMatrix12 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix264867"
  })), _feColorMatrix13 || (_feColorMatrix13 = /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "feColorMatrix264869",
    in: "fbSourceGraphic",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 -0.2125 -0.7154 -0.0721 1 0 ",
    result: "colormatrix"
  })), _feComposite27 || (_feComposite27 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "colormatrix",
    id: "feComposite264871",
    in: "fbSourceGraphic",
    operator: "arithmetic",
    k2: 1,
    k3: 0,
    k4: 0,
    result: "composite",
    k1: 0
  })), _feGaussianBlur47 || (_feGaussianBlur47 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur264873",
    stdDeviation: "5.21698 0.01",
    result: "blur1"
  })), _feGaussianBlur48 || (_feGaussianBlur48 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur264875",
    in: "composite",
    stdDeviation: "0.01 0.01",
    result: "blur2"
  })), _feBlend5 || (_feBlend5 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blur1",
    id: "feBlend264877",
    in: "blur2",
    mode: "darken",
    result: "blend"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter300240",
    x: -0.029060442,
    y: -0.029249686,
    width: 1.0732565,
    height: 1.0737336
  }, _feGaussianBlur49 || (_feGaussianBlur49 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "result0",
    in: "SourceAlpha",
    stdDeviation: 4,
    id: "feGaussianBlur300234"
  })), _feOffset4 || (_feOffset4 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    result: "result4",
    id: "feOffset300236"
  })), _feComposite28 || (_feComposite28 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "result4",
    operator: "xor",
    result: "result3",
    id: "feComposite300238"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter300448",
    x: -0.054375886,
    y: -0.049740933,
    width: 1.1314084,
    height: 1.1202073
  }, _feColorMatrix14 || (_feColorMatrix14 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0.72 0.07 0 0 ",
    result: "result1",
    id: "feColorMatrix300420"
  })), _feColorMatrix15 || (_feColorMatrix15 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 2 0 ",
    result: "result9",
    id: "feColorMatrix300422"
  })), _feComposite29 || (_feComposite29 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result9",
    in: "SourceGraphic",
    operator: "in",
    result: "result4",
    id: "feComposite300424"
  })), _feFlood2 || (_feFlood2 = /*#__PURE__*/React.createElement("feFlood", {
    result: "result2",
    floodColor: "rgb(0,0,0)",
    id: "feFlood300426"
  })), _feComposite30 || (_feComposite30 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result9",
    operator: "in",
    result: "result10",
    id: "feComposite300428"
  })), _feComposite31 || (_feComposite31 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "result4",
    operator: "atop",
    id: "feComposite300430"
  })), _feGaussianBlur50 || (_feGaussianBlur50 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "result8",
    id: "feGaussianBlur300432"
  })), _feOffset5 || (_feOffset5 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    result: "result3",
    in: "result8",
    id: "feOffset300434"
  })), _feFlood3 || (_feFlood3 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 1,
    floodColor: "rgb(219,173,62)",
    result: "result5",
    id: "feFlood300436"
  })), _feMerge || (_feMerge = /*#__PURE__*/React.createElement("feMerge", {
    result: "result6",
    id: "feMerge300444"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "result5",
    id: "feMergeNode300438"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "result3",
    id: "feMergeNode300440"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "result4",
    id: "feMergeNode300442"
  }))), _feComposite32 || (_feComposite32 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic",
    id: "feComposite300446"
  })), _feColorMatrix16 || (_feColorMatrix16 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix300526"
  })), _feOffset6 || (_feOffset6 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset300528",
    dy: 3,
    dx: 3,
    in: "fbSourceGraphic"
  })), _feGaussianBlur51 || (_feGaussianBlur51 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur300530",
    stdDeviation: 3,
    result: "blur"
  })), _feFlood4 || (_feFlood4 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood300532",
    floodColor: "rgb(0,0,0)",
    floodOpacity: 1,
    result: "flood"
  })), _feComposite33 || (_feComposite33 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "fbSourceGraphic",
    id: "feComposite300534",
    in: "flood",
    operator: "in",
    result: "composite"
  })), _feBlend6 || (_feBlend6 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "composite",
    id: "feBlend300536",
    in: "blur",
    mode: "normal"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter306750",
    x: -0.11131644,
    y: -0.087531674,
    width: 1.2806102,
    height: 1.2206528
  }, _feGaussianBlur52 || (_feGaussianBlur52 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "result0",
    in: "SourceAlpha",
    stdDeviation: 4,
    id: "feGaussianBlur306744"
  })), _feOffset7 || (_feOffset7 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    result: "result4",
    id: "feOffset306746"
  })), _feComposite34 || (_feComposite34 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "result4",
    operator: "xor",
    result: "result3",
    id: "feComposite306748"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath318411"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#083a42",
      strokeWidth: 9,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 44.9997,
      strokeOpacity: 1
    },
    id: "rect318413",
    width: 504.01425,
    height: 504.01425,
    x: 1940.2632,
    y: -676.83838
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath353188"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#083a42",
      strokeWidth: 10.2586,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 44.9997,
      strokeOpacity: 1
    },
    id: "rect353190",
    width: 1643.9764,
    height: 1449.6002,
    x: 3337.5151,
    y: -2292.5364,
    transform: "matrix(0.83327478,0.55285906,0.10646544,0.9943164,0,0)"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient5841",
    id: "linearGradient5843",
    x1: 1024.0276,
    y1: 139.27296,
    x2: 1024.0276,
    y2: 467.53473,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter11020",
    x: -0.0082663884,
    y: -0.022415246,
    width: 1.0165328,
    height: 1.0448305
  }, _feGaussianBlur53 || (_feGaussianBlur53 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.2656801,
    id: "feGaussianBlur11022"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient11611",
    id: "linearGradient11613",
    x1: 1024.0276,
    y1: 139.27296,
    x2: 1024.0276,
    y2: 467.53473,
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer12",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer6",
    style: {
      fill: "#86cfda"
    }
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text470",
    style: {
      fontSize: 350,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      whiteSpace: "pre",
      shapeInside: "url(#rect472)",
      fill: "url(#linearGradient5843)",
      fillOpacity: 1,
      stroke: "none",
      strokeOpacity: 0.54386,
      filter: "url(#filter11020)"
    },
    transform: "matrix(1.103278,0,0,1.9132372,-177.40631,-150.60005)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 659.02344,
    y: 399.92499,
    id: "tspan18551"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'sans-serif Bold'"
    },
    id: "tspan18549"
  }, "404"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Sands1);
export default __webpack_public_path__ + "static/media/404sands1.de5eb320a154f98f65d10cedb27c351b.svg";
export { ForwardRef as ReactComponent };